import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=1a7a325c&scoped=true&"
import script from "./platform.vue?vue&type=script&lang=ts&"
export * from "./platform.vue?vue&type=script&lang=ts&"
import style0 from "./platform.vue?vue&type=style&index=0&id=1a7a325c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a325c",
  null
  
)

export default component.exports